import PostModel from "./postModel";
export default function widgetModel(config, rawWidget) {
    var _a, _b, _c, _d, _e, _f, _g;
    if ((!(rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.code) ||
        ((_a = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.code) === null || _a === void 0 ? void 0 : _a.includes("script")) ||
        ((_b = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.code) === null || _b === void 0 ? void 0 : _b.includes("amp"))) &&
        !((_c = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.code) === null || _c === void 0 ? void 0 : _c.includes("campaign"))) {
        return undefined;
    }
    const postMapper = new PostModel(config);
    const posts = (_e = (_d = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.posts) === null || _d === void 0 ? void 0 : _d.map((post) => postMapper.mapPost(post))) !== null && _e !== void 0 ? _e : [];
    return {
        title: rawWidget.title,
        code: rawWidget.code,
        style: rawWidget.style,
        location: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.location,
        groupTitle: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.groupTitle,
        group: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.group,
        mainPost: posts && posts.length > 0 ? posts[0] : null,
        moreLink: rawWidget.moreLink,
        loadMoreLink: rawWidget.loadMoreLink,
        widgetImage: rawWidget.widgetImage
            ? config.MEDIA_URL + rawWidget.widgetImage
            : undefined,
        posts,
        tabData: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.tabData,
        apiAdvertisement: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.apiAdvertisement,
        mobileWidgetKey: rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.mobileWidgetKey,
        widgetColor: (_f = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.viewOptions) === null || _f === void 0 ? void 0 : _f.Color,
        subMenus: (_g = rawWidget === null || rawWidget === void 0 ? void 0 : rawWidget.viewOptions) === null || _g === void 0 ? void 0 : _g.SubMenus,
    };
}
